import { HeroProps, HeroRoundedCornersType, HeroAlignmentType, HeroOptionsType } from "../types";

const cornerClasses = {
    topLeft: {
        none: "",
        sm: "cui-rounded-tl-sm",
        md: "cui-rounded-tl-md",
        lg: "cui-rounded-tl-lg",
        xl: "cui-rounded-tl-xl",
        full: "cui-rounded-tl-full"
    },
    topRight: {
        none: "",
        sm: "cui-rounded-tr-sm",
        md: "cui-rounded-tr-md",
        lg: "cui-rounded-tr-lg",
        xl: "cui-rounded-tr-xl",
        full: "cui-rounded-tr-full"
    },
    bottomLeft: {
        none: "",
        sm: "cui-rounded-bl-sm",
        md: "cui-rounded-bl-md",
        lg: "cui-rounded-bl-lg",
        xl: "cui-rounded-bl-xl",
        full: "cui-rounded-bl-full"
    },
    bottomRight: {
        none: "",
        sm: "cui-rounded-br-sm",
        md: "cui-rounded-br-md",
        lg: "cui-rounded-br-lg",
        xl: "cui-rounded-br-xl",
        full: "cui-rounded-br-full"
    }
};

const roundedClasses: Record<string, string> = {
    none: "",
    sm: "cui-rounded-sm",
    md: "cui-rounded-md",
    lg: "cui-rounded-lg",
    xl: "cui-rounded-xl",
    full: "cui-rounded-full"
};

export function getRoundedClasses(rounded: HeroProps["rounded"]) {
    if (!rounded) return "";
    if (typeof rounded === "string") return roundedClasses[rounded] || "";
    const { topLeft, topRight, bottomLeft, bottomRight } = rounded as HeroRoundedCornersType;
    return [
        topLeft && cornerClasses.topLeft[topLeft],
        topRight && cornerClasses.topRight[topRight],
        bottomLeft && cornerClasses.bottomLeft[bottomLeft],
        bottomRight && cornerClasses.bottomRight[bottomRight],
    ].filter(Boolean).join(" ");
}

const screenStyles: Record<string, string | null> = {
    dark: "rgba(0,0,0,0.65)",
    normal: null,
    light: "rgba(255,255,255,0.25)"
};

const colorMap: Record<string, string> = {
    white: "255,255,255",
    black: "0,0,0"
};

export function getScreenStyle(screen: HeroProps["screen"]): string | null {
    if (!screen || screen === "normal") return null;
    if (typeof screen === "string") return screenStyles[screen];
    const { color, opacity } = screen;
    const rgb = colorMap[color] || color;
    if (rgb.startsWith("rgba") || rgb.startsWith("#")) return color;
    return `rgba(${rgb},${opacity})`;
}

export const alignmentStyles: Record<HeroAlignmentType, string> = {
    topLeft: "cui-items-start cui-justify-start",
    leftCenter: "cui-items-start cui-justify-center",
    bottomLeft: "cui-items-start cui-justify-end",
    center: "cui-items-center cui-justify-center",
    topRight: "cui-items-end cui-justify-start",
    rightCenter: "cui-items-end cui-justify-center",
    bottomRight: "cui-items-end cui-justify-end"
};

export const defaultOptions: HeroOptionsType = {
    subtext1TextColor: "fg-global-white",
    subtext1TextSize: "body-xs",
    subtext1Classes: "",
    titleTextColor: "fg-global-white",
    titleTextSize: "display-md-bold",
    titleClasses: "",
    subtext2TextColor: "fg-global-white",
    subtext2TextSize: "body-xs",
    subtext2Classes: "",
    subtext3TextColor: "fg-global-white",
    subtext3TextSize: "",
    subtext3Classes: "",
};
